<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetSiteInformation widgetNoTopBorder" *ngIf="widgetData">
  <div class="table-part">
    <table style="height: 100%; table-layout: auto;" aria-hidden="true">
      <thead>
        <tr class="dark-grey-line header-part">
          <td class="widget-grid-column">
            <widget-label [widget]="this" [fieldName]="'tenantLeaseName'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small">
            <widget-label [widget]="this" [fieldName]="'tenantTenantUse'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small">
            <widget-label [widget]="this" [fieldName]="'tenantArea'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small" *ngIf="currentLayout === 'with WALB'">
            <widget-label [widget]="this" [fieldName]="'tenantWALB'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small">
            <widget-label [widget]="this" [fieldName]="'tenantWALT'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-large">
            <widget-label [widget]="this" [fieldName]="'indexationMarketReview'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small">
            <widget-label [widget]="this" [fieldName]="'tenantCovenant'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small">
            <widget-label [widget]="this" [fieldName]="'tenantContractedRent'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column">
            <widget-label [widget]="this" [fieldName]="'tenantERVShare'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small">
            <widget-label [widget]="this" [fieldName]="'tenantERVShare'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column widget-input-text-small">
            <widget-label [widget]="this" [fieldName]="'tenantReversionCalc'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
          <td class="widget-grid-column">
            <widget-label [widget]="this" [fieldName]="'comment'" [align]="'center'" [color]="'white'" [bold]="true"></widget-label>
          </td>
        </tr>
        <tr class="dark-grey-line header-part">
          <th scope="col" class="widget-grid-column" style="text-align: center;">&nbsp;</th>
          <th scope="col" class="widget-grid-column" style="text-align: center;">&nbsp;</th>
          <th scope="col" class="widget-grid-column" style="text-align: center;">{{unitOfArea}}</th>
          <th scope="col" class="widget-grid-column widget-input-text-small" style="text-align: center;" *ngIf="currentLayout === 'with WALB'">&nbsp;</th>
          <th scope="col" class="widget-grid-column widget-input-text-small" style="text-align: center;">&nbsp;</th>
          <th scope="col" class="widget-grid-column" style="text-align: center;">&nbsp;</th>
          <th scope="col" class="widget-grid-column" style="text-align: center;">&nbsp;</th>
          <th scope="col" class="widget-grid-column" style="text-align: center;">
            {{currency}} / pa
          </th>
          <th scope="col" class="widget-grid-column" style="text-align: center;">
            {{currency}} / pa
          </th>
          <th scope="col" class="widget-grid-column widget-input-text-small" style="text-align: center;">%</th>
          <th scope="col" class="widget-grid-column widget-input-text-small" style="text-align: center;">%</th>
          <th scope="col" class="widget-grid-column" style="text-align: center;">&nbsp;</th>
        </tr>
      </thead>
      <tbody class="viewModeTbody">
        <tr *ngFor="let tenant of widgetData.keyTenants; let index=index"
            [ngClass]="{'light-grey-line': index%2!=0, 'white-line':index%2==0}">
          <td>
            <widget-value [align]="'left'">{{tenant.tenantLeaseName  }} </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'">{{tenant.tenantTenantUse }} </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'">{{tenant.tenantArea | rdLocalizedNumber:0 }} </widget-value>
          </td>

          <td *ngIf="currentLayout === 'with WALB'">
            <widget-value [align]="'center'">{{tenant.tenantWALB | rdLocalizedNumber:2 }} </widget-value>
          </td>

          <td>
            <widget-value [align]="'center'">{{tenant.tenantWALT | rdLocalizedNumber:2 }} </widget-value>
          </td>

          <td *ngIf="!editMode || tenant.tenantId == 0">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{tenant.indexationMarketReview}}</label> </widget-value>
          </td>
          <td *ngIf="editMode && tenant.tenantId != 0" class="text-field-container">
            <input type="text" [(ngModel)]="tenant.indexationMarketReview"    
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="tenant.indexationMarketReview= $event;"
            id="indexationMarketReview" class="widget-input-text widget-align-right input-main-tenant-width gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>

          <td *ngIf="!editMode || tenant.tenantId == 0">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{tenant.tenantCovenant}}</label> </widget-value>
          </td>
          <td *ngIf="editMode && tenant.tenantId != 0" class="text-field-container">
            <input type="text" [(ngModel)]="tenant.tenantCovenant"    
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="tenant.tenantCovenant= $event;"
            id="tenantCovenant" class="widget-input-text widget-align-right input-main-tenant-width gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
          <td>
            <widget-value [align]="'center'">{{tenant.tenantContractedRent | rdLocalizedNumber:0 }} </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'">{{tenant.tenantRentalValue | rdLocalizedNumber:0 }} </widget-value>
          </td>
          <td>
            <widget-value *ngIf="tenant.tenantStatus !== 'let'" [align]="'center'">n/a</widget-value>
            <widget-value *ngIf="tenant.tenantStatus === 'let'" [align]="'center'">{{tenant.tenantERVShare * 100| rdLocalizedNumber:1 }}%</widget-value>
          </td>

          <td *ngIf="!editMode || tenant.tenantId == 0">
            <widget-value *ngIf="tenant.tenantStatus !== 'let'" [align]="'center'">n/a</widget-value>
            <widget-value *ngIf="tenant.tenantStatus === 'let'" [align]="'center'">{{tenant.tenantReversionCalc | rdLocalizedNumber:1 }}%</widget-value>
          </td>
          <td *ngIf="editMode && tenant.tenantId != 0">
            <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="tenant.tenantReversionCalc" (valueChange)="setDirtyFlag(true); updateTenantReversion(tenant)" [isNullable]="true" [decimals]="1" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
          </td>

          <td *ngIf="!editMode || tenant.tenantId == 0">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{(tenant.comment || "")}}</label> </widget-value>
          </td>
          <td *ngIf="editMode && tenant.tenantId != 0" class="text-field-container">
            <input type="text" [(ngModel)]="tenant.comment"    
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="tenant.comment= $event;"
            id="ktcomment" class="widget-input-text widget-align-right input-main-tenant-width gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>

        <tr class="total-row">
          <td>
            <widget-label [widget]="this" [fieldName]="'labelTotal'" [align]="'left'" [bold]="true"></widget-label>
          </td>
          <td>&nbsp;</td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.totalLettableArea | rdLocalizedNumber:0 }}
            </widget-value>
          </td>

          <td *ngIf="currentLayout === 'with WALB'">
            <widget-value [align]="'center'" [bold]="true">{{widgetData.totalWALB | rdLocalizedNumber:2 }}</widget-value>
          </td>

          <td>
            <widget-value [align]="'center'" [bold]="true">{{widgetData.totalWALT | rdLocalizedNumber:2 }}</widget-value>
          </td>

          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.totalTenantContractedRent | rdLocalizedNumber:0 }}
            </widget-value>
          </td>
          <td>
            <widget-value [align]="'center'" [bold]="true">
              {{widgetData.totalRentalValue | rdLocalizedNumber:0 }}
            </widget-value>
          </td>
          <td>&nbsp;</td>

          <td *ngIf="!editMode">
            <widget-value [align]="'center'" [bold]="true">{{widgetData.totalReversionCalc | rdLocalizedNumber:1 }}%</widget-value>
          </td>
          <td *ngIf="editMode">
            <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.totalReversionCalc" (valueChange)="setDirtyFlag(true); updateTotalReversion()" [isNullable]="true" [decimals]="1" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
          </td>

          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="space-part">&nbsp;</div>
</div>
